import {
  clearStoredAuthData,
  getStoredAuthData,
  saveAuthData,
  clearAuthFlowLocalContext,
} from 'js/library/services/authSession';
import { refreshToken } from './refreshToken';

export const ACCESS_TOKEN_REFRESH_LEAD_TIME_MS = 20 * 60 * 1000;
export const SESSION_EVENT = 'triibo:access-token-updated';

let refreshInFlightPromise = null;

export const getAccessTokenExpiration = (accessToken) => {
  const expires = Number(accessToken?.expires);

  return Number.isFinite(expires) ? expires : null;
};

export const isAccessTokenDueForRefresh = (
  accessToken,
  leadTimeMs = ACCESS_TOKEN_REFRESH_LEAD_TIME_MS
) => {
  const expiresAt = getAccessTokenExpiration(accessToken);
  if (expiresAt === null) return false;

  return expiresAt - Date.now() <= leadTimeMs;
};

const notifyAccessTokenUpdated = (accessToken) => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new window.CustomEvent(SESSION_EVENT, {
      detail: { accessToken },
    })
  );
};

export const persistAccessToken = (accessToken) => {
  const authData = getStoredAuthData();

  if (authData) {
    saveAuthData({
      ...authData,
      accessToken,
    });
  }

  notifyAccessTokenUpdated(accessToken);
};

const clearInvalidSession = () => {
  clearStoredAuthData();
  clearAuthFlowLocalContext();

  if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
};

const createRefreshError = (response) => {
  const error = new Error(response?.error || 'Erro ao renovar sessão');
  error.authRefreshFailed = true;
  error.responseData = response;

  return error;
};

export const refreshAccessToken = () => {
  if (refreshInFlightPromise) return refreshInFlightPromise;

  refreshInFlightPromise = (async () => {
    try {
      const response = await refreshToken();

      if (!response?.success || !response?.data?.accessToken) {
        throw createRefreshError(response);
      }

      persistAccessToken(response.data.accessToken);

      return response.data.accessToken;
    } catch (error) {
      clearInvalidSession();
      throw error;
    } finally {
      refreshInFlightPromise = null;
    }
  })();

  return refreshInFlightPromise;
};

export const subscribeToAccessTokenUpdates = (listener) => {
  if (typeof window === 'undefined') return () => {};

  const handleUpdate = (event) => listener(event.detail?.accessToken);
  window.addEventListener(SESSION_EVENT, handleUpdate);

  return () => window.removeEventListener(SESSION_EVENT, handleUpdate);
};
